import { Box, Container, SxProps } from '@mui/system'
import { shadows } from 'c1ui'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { FC, ReactNode } from 'react'

type FloatingBarProps = {
    sx?: SxProps,
    onTransitionEnd?: () => void,
    children: ReactNode,
}

export const FloatingBar: FC<FloatingBarProps> = ({ sx, onTransitionEnd, children }) => {
    return (
        <Box
            onTransitionEnd={onTransitionEnd}
            sx={{
                position: 'fixed',
                right: 0,
                bottom: 0,
                zIndex: 1000,
                ...sx,
            }}
        >
            <Container sx={{ py: 0, px: 6 }}>
                <Box sx={{
                    backgroundColor: 'background.default',
                    borderRadius: C1BorderRadius.large,
                    boxShadow: shadows.strong,
                    padding: 2,
                    mx: 3,
                }}
                >
                    {children}
                </Box>
            </Container>
        </Box>
    )
}
